import __var_0__ from '@stdlib/math/base/assert/is-nan';
import __var_1__ from '@stdlib/math/base/special/gamma';
import __var_2__ from '@stdlib/constants/math/float64-sqrt-two';
/**

*
* Copyright (c) 2018 The Stdlib Authors.
*
* Licensed under the Apache License, Version 2.0 (the "License");
* you may not use this file except in compliance with the License.
* You may obtain a copy of the License at
*
*    http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing, software
* distributed under the License is distributed on an "AS IS" BASIS,
* WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
* See the License for the specific language governing permissions and
* limitations under the License.
*/

'use strict';

// MODULES //
var isnan = __var_0__;
var gamma = __var_1__;
var SQRT_TWO = __var_2__;


// MAIN //

/**
* Returns the expected value of a chi distribution.
*
* @param {NonNegativeNumber} k - degrees of freedom
* @returns {NonNegativeNumber} expected value
*
* @example
* var v = mean( 9.0 );
* // returns ~2.918
*
* @example
* var v = mean( 1.0 );
* // returns ~0.798
*
* @example
* var v = mean( -0.2 );
* // returns NaN
*
* @example
* var v = mean( NaN );
* // returns NaN
*/
function mean( k ) {
	if ( isnan( k ) || k < 0.0 ) {
		return NaN;
	}
	return SQRT_TWO * gamma( ( k+1.0 ) / 2.0 ) / gamma( k / 2.0 );
}


// EXPORTS //
export default mean;
